import { Box } from '@mui/material';
import belnickLogo from 'assets/logo-340x100-belnickinc.png';
export function BelnickLogo() {
    return (
        <Box
            component='img'
            sx={theme => ({ maxHeight: theme.mixins.toolbar.minHeight })}
            src={belnickLogo}
            alt='belnick logo'
        />
    );
}
